import { useSyncExternalStore } from 'react';
import { recorderStore } from './recorderStore.js';

export function useIsRecording(): boolean {
  return useSyncExternalStore(
    recorderStore.subscribe,
    () => recorderStore.getState().isRecording,
    () => false,
  );
}

export function useTripDistance(): number {
  return useSyncExternalStore(
    recorderStore.subscribe,
    () => recorderStore.getState().tripDistanceNm,
    () => 0,
  );
}
